import request from '../utils/request'

export function getArticleDetail(id) {
  return request.get(`/api/cms/articles/${id}`)
}

export function getPrevNext(id, params) {
  return request.get(`/api/cms/articles/${id}/prev-next`, { params })
}

export function submitMessage(data) {
  return request.post('/api/cms/messages', data)
}

export function getConfig() {
  return request.get('/api/cms/config')
}

export function getFaq(q) {
  return request.get('/api/cms/faq', { params: { q } })
}

export function getLeaders(params = {}) {
  const defaults = { lang: 'zh', pageNum: 1, pageSize: 10 }
  return request.get('/api/cms/leaders', { params: { ...defaults, ...params } })
}

export function getArticles(params) {
  return request.get('/api/cms/articles', { params })
}

export function getWeather() {
  return request.get('/api/cms/weather')
}

export function getMapKey() {
  return request.get('/api/cms/map-key')
}

export function getGallery(lang = 'zh') {
  return request.get('/api/cms/gallery', { params: { lang } })
}

export function getHomePage(lang = 'zh') {
  return request.get('/api/cms/homepage', { params: { lang } })
}

export function getNewsList(params) {
  return request.get('/news/list', { params })
}

export function getNoticeList(params) {
  return request.get('/notice/list', { params })
}

export function getIndustryList(params) {
  return request.get('/industry/list', { params })
}

export function getGovList(params) {
  return request.get('/gov/list', { params })
}

export function getConsultList(params) {
  return request.get('/consult/list', { params })
}

export function getSceneList(params) {
  return request.get('/scene/list', { params })
}

export function getCarouselList() {
  return request.get('/carousel/list')
}


